import React from 'react';
import TrainingSessionLoginForm from './TrainingSessionLogin';

const TrainingSessionTab = ({ props, setRecoverPassword, recoverPassword }) => (
    <>
        <TrainingSessionLoginForm {...props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} />
    </>
);

export default TrainingSessionTab;